import Layout from '@/components/layout/Layout.vue'
import { updatePassword } from '@/api/user'

export default {
    components: {
        Layout
    },
    data () {
        return {
            labelCol: {
                sm: { span: 4 },
                lg: { span: 4 }
            },
            wrapperCol: {
                sm: { span: 18 },
                lg: { span: 18 }
            },
            offsetCol: { span: 18, offset: 4 },
            model: {},
            loading: false,
            rules: {
                password_original: [{ required: true, message: '请输入原密码', trigger: 'change' }],
                password: [{ required: true, message: '请输入新密码', trigger: 'change' }],
                password_confirmation: [{ required: true, message: '请再次输入密码', trigger: 'change' }],
            },
        }
    },
    computed: {
    },
    mounted () {
    },
    methods: {
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                this.update()
            });
        },
        update() {
            this.loading = true
            updatePassword(this.model).then(() => {
                this.$message.destroy()
                this.$message.success('修改成功')
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        }
    }
}
